import { render, staticRenderFns } from "./BatchSessionUpdateModal.vue?vue&type=template&id=5cdcfeea&scoped=true"
import script from "./BatchSessionUpdateModal.vue?vue&type=script&lang=js"
export * from "./BatchSessionUpdateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdcfeea",
  null
  
)

export default component.exports